import { render, staticRenderFns } from "./player-card-order-list.vue?vue&type=template&id=385d6454&scoped=true&"
import script from "./player-card-order-list.vue?vue&type=script&lang=js&"
export * from "./player-card-order-list.vue?vue&type=script&lang=js&"
import style0 from "./player-card-order-list.vue?vue&type=style&index=0&id=385d6454&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "385d6454",
  null
  
)

export default component.exports